import { createSlice } from '@reduxjs/toolkit';

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    data: [],
    loading: true,

  },
  reducers: {
    hydrateNotifications: (state, action) => {
      state.data = action.payload;
      state.loading = false;
    },
    addMoreNotifications: (state, action) => {
      state.data = state.data.concat(action.payload);
    },
    requestNotifications: (state, action) => {
      state.loading = true;
    },
    readNotification: (state, action) => {
      const notificationIndex = state.data.findIndex(
        (n) => n.id === action.payload
      );
      if (notificationIndex >= 0) {
        // with Immer you can mutate directly
        state.data[notificationIndex].viewed = true;
      }
    },
    deleteSingleNotification: (state, action) => {
      state.data = state.data.filter((notification) => notification.id !== action.payload);
    },
  },
});

export default notificationsSlice;
